import { FieldPolicy } from '@apollo/client'

export const NotesPolicy: FieldPolicy = {
  merge(oldV, newV) {
    // We don't actually merge, as deleting an entry is a meaningful action.
    return newV
  },
}
